import { BaseError } from "./BaseError";
import type { ErrorContext } from "../types/index";
import { DATABASE_ERROR_CODES } from "../constants/errorCodes";

export interface DatabaseErrorOptions {
  message: string;
  query?: string;
  table?: string;
  constraint?: string;
  context?: Partial<ErrorContext>;
  code?: string;
  cause?: Error;
}

/**
 * Error thrown for database-related issues
 */
export class DatabaseError extends BaseError {
  public readonly query?: string;
  public readonly table?: string;
  public readonly constraint?: string;

  constructor(options: DatabaseErrorOptions) {
    super({
      message: options.message,
      category: "database",
      severity: "high",
      statusCode: 500,
      code: options.code ?? DATABASE_ERROR_CODES.DATABASE_ERROR,
      context: options.context,
      cause: options.cause,
      userVisible: false,
      reportable: true,
    });

    this.query = options.query;
    this.table = options.table;
    this.constraint = options.constraint;
  }
}
